export const hubConfigs = {
    stopHub: {
        url: '/api/StopHub'
        // Define how to handle incoming events from this hub
        // Example code
        // eventHandlers: (store) => {
        //   return {
        //     'AssignmentStatus': (message) => {
        //         console.log('Received AssignmentStatus:', message);
        //         store.commit('stops/ASSIGNMENT_STATUS', message, { root: true })
        //     },
        //   };
        // }
    },
    invoicingHub: {
        url: '/api/InvoicingHub'
    },
    jobHub: {
        url: '/api/JobHub'
    },
    ratesEngineUpdateHub: {
        url: '/api/RatesEngineUpdateHub'
    },
    carrierHub: {
        url: '/api/CarrierHub'
    },
    shipmentHub: {
        url: '/api/ShipmentHub'
    },
    imageHub: {
        url: '/api/ImageHub'
    },
    tripCreationHub: {
        url: '/api/TripCreatedHub'
    },
    locationHub: {
        url: '/api/LocationHub'
    }
};
